// サーベイセットのメタ情報·形式構造
// サーバ側 config/surveyFormat.js と同期している

// 360度診断のtype_360別の構造定義
// 6x5 = 大カテゴリ 6個 × 各 5問 = 客観式 30問
// 6x5 と 5x6 は総数 30 で同じだが、構造で区別する
// cup / 3x3x5 / eleader / gates / initiative は構造未定義のため検証スキップ
export const SURVEY_FORMAT_STRUCTURE = {
  '6x5': { categories: 6, perCategory: 5 },
  '5x6': { categories: 5, perCategory: 6 },
  '6x6': { categories: 6, perCategory: 6 },
};

// Web個人結果に対応済みの40010形式。本人・管理者の導線で共用する。
export const TRADITIONAL_40010_TYPES = ['cup', '6x6', '6x5', '5x6'];

// Web結果の導入前から「結果確認」（PDF 1つ）だった40010形式。
export const SINGLE_PDF_40010_TYPES = [
  '3x3x5',
  'gates',
  'initiative',
  'eleader',
];

export const WEB_RESULT_40010_TYPES = [
  ...TRADITIONAL_40010_TYPES,
  ...SINGLE_PDF_40010_TYPES,
];

// ★暫定（2026-10-27）: 360度診断・フォロワーシップ診断の Web 結果は開発中のため、特権管理者（9）だけに見せる
// （サーバーの result60020Access.js の WEB_OPEN_ROLES と同じ）。それ以外のロールは従来の PDF ボタンのまま。
// 本格リリース時はこの制限を外す。
export const WEB_RESULT_360_ROLES = [9];
export const isWeb360OpenFor = (role) =>
  WEB_RESULT_360_ROLES.includes(Number(role));
